import { render, staticRenderFns } from "./GlobalSmartSearch.vue?vue&type=template&id=62f8b52d&scoped=true&"
import script from "./GlobalSmartSearch.vue?vue&type=script&lang=js&"
export * from "./GlobalSmartSearch.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSmartSearch.vue?vue&type=style&index=0&id=62f8b52d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f8b52d",
  null
  
)

export default component.exports